import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import Container from '@/components/Container';
import Link from '@/components/Link';

const defaultProps = {
  menu: [],
};

const propTypes = {
  pageTitle: PropTypes.node.isRequired,
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
};

export default function HeaderSub({ pageTitle, menu }) {
  const router = useRouter();

  const hasPageTitle = pageTitle !== null;

  return (
    <Container>
      <div className="relative z-20 flex items-center py-4 overflow-y-auto lg:py-6">
        {hasPageTitle && (
          <div className="flex-1">
            <h2 className="hidden text-base font-semibold text-gray-900 md:block lg:text-lg xl:text-xl">
              {pageTitle}
            </h2>
          </div>
        )}
        <nav className="flex items-center max-w-full space-x-6">
          {menu.map(({ title, url, useArrow }, index) => (
            <Link
              key={`sub-menu-${index}-${url}`}
              className={clsx(
                'flex items-center space-x-2 whitespace-nowrap',
                router.pathname === url &&
                  ' cursor-default font-normal text-gray-500',
                router.pathname !== url &&
                  'font-semibold text-green-600 hover:text-gray-900'
              )}
              href={url}
            >
              <div className="text-base leading-4">{title}</div>
              {useArrow && (
                <svg
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </Link>
          ))}
        </nav>
      </div>
    </Container>
  );
}

HeaderSub.defaultProps = defaultProps;
HeaderSub.propTypes = propTypes;
